import React, { useEffect, useState } from 'react';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Grid from '@mui/material/Grid2';
import { Links } from './Links';
import Slide from '@mui/material/Slide';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import makeStyles from '@mui/styles/makeStyles';
import { useGlobalSearchController } from '../../GlobalSearch/GlobalSearch.controller';
import { useSearchModalController } from '../../GlobalSearch/SearchModal/SearchModal.controller';

const useStyles = makeStyles((theme) => ({
  root: {
    borderTop: 'solid thin black',
    position: 'absolute',
    top: 'calc(-7px - 100%)',
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: 'transparent',
    alignItems: 'center',
    overflow: 'auto',
  },
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  titleGrid: {
    width: '100%',
    order: 1,
    flexBasis: 'auto',
  },
  infoGrid: {
    width: '100%',
    maxHeight: '60%',
    order: 2,
  },
  closeGrid: {
    flexShrink: 0,
    order: 3,
    width: 'fit-content',
    alignSelf: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    ...theme.palette.primaryBackground,
    fontSize: theme.fontSizes.bigger,
  },
  bold: {
    fontWeight: 'bold',
  },
  border: {
    borderBottom: 'solid thin black',
  },
  info: {
    backgroundColor: 'white',
    color: theme.palette.baseColors.deepSeaNavy.c100,
    fontSize: theme.fontSizes.smaller,
  },
  close: {
    ...theme.palette.secondaryBackground,
    width: 'fit-content',
    padding: '0 25px',
    borderBottomLeftRadius: '5px',
    borderBottomRightRadius: '5px',
    cursor: 'pointer',
  },
  slideGridContainer: {
    position: 'relative',
    height: '100%',
  },
}));

// Only these aggregates support displaying the info panel:
const SUPPORTED_INFO_PANEL_AGGREGATES = ['Country', 'Asset'];

export const InfoPanel = ({ aggregate, container, clickedFeature, setClickedFeature }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const { setHistory } = useGlobalSearchController();
  const closePanel = () => setClickedFeature({});

  useEffect(() => {
    if (clickedFeature.label && SUPPORTED_INFO_PANEL_AGGREGATES.includes(aggregate)) {
      setOpen(true);
    } else {
      setOpen(false);
      if (clickedFeature.label) setClickedFeature({});
    }
  }, [clickedFeature, aggregate]);

  const { data, loading, called, onActionClick } = useSearchModalController({
    inputText: clickedFeature.label,
    labelGroups: [{ labels: [aggregate] }],
    setHistory,
  });

  return (
    <Slide direction="down" in={open} container={container}>
      <div className={classes.slideGridContainer}>
        <Grid
          className={clsx(classes.root, classes.container)}
          style={{
            width: container?.offsetWidth,
            height: container?.offsetHeight,
          }}
        >
          <Grid className={clsx(classes.title, classes.titleGrid)} padding="5px 10px">
            <Typography className={clsx({ [classes.title]: true, [classes.bold]: true })}>
              {clickedFeature.label}
            </Typography>
          </Grid>
          <Grid className={clsx(classes.info, classes.border, classes.infoGrid)} padding="5px 10px">
            <Links
              styles={classes}
              loading={(!data && called) || loading}
              rows={data?.fulltextSearch || []}
              aggregate={aggregate}
              onActionClick={onActionClick}
            />
          </Grid>
          <Grid onClick={closePanel} className={clsx(classes.close, classes.closeGrid)}>
            <ExpandLessIcon />
          </Grid>
        </Grid>
      </div>
    </Slide>
  );
};
